import MitigationInformation from './MitigationInformation';
import LocationInformation from './LocationInformation';
import StructureAttributes from './StructureAttributes';
import InsuranceInformation from './InsuranceInformation';
import CostEffectivenessInformation from './CostEffectivenessInformation';
import GreenspaceAcreage from './GreenspaceAcreage';
import OwnerInformation from './OwnerInformation';

export {
  MitigationInformation,
  LocationInformation,
  StructureAttributes,
  InsuranceInformation,
  CostEffectivenessInformation,
  GreenspaceAcreage,
  OwnerInformation,
};
